const config = {
    googleScriptUrl: process.env.REACT_APP_GOOGLE_SCRIPT_URL
};

export default config;
